import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ProductCard from "@/components/product/ProductCard";

export default function FeaturedProducts({ products, categoryMap }) {
  return (
    <section className="py-24 bg-slate-50" data-testid="featured-products-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-end justify-between mb-14 flex-wrap gap-4">
          <div>
            <span className="text-xs tracking-[0.2em] uppercase font-semibold text-brandblue-600">Featured Compounds</span>
            <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight font-medium text-slate-900 font-display">Laboratory-Verified Research Peptides</h2>
          </div>
          <Link to="/shop" className="inline-flex items-center text-sm font-semibold text-slate-900 hover:text-brandblue-600" data-testid="view-all-products-link">
            View All Compounds <ArrowRight className="h-4 w-4 ml-1.5" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((p) => (
            <ProductCard key={p.slug} product={p} categorySlug={categoryMap?.[p.category_id]} />
          ))}
        </div>
      </div>
    </section>
  );
}
